import script from "./ProductManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductManager.vue?vue&type=script&setup=true&lang=ts"

import "./ProductManager.vue?vue&type=style&index=0&id=1b93dfd6&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b93dfd6"]])

export default __exports__